import _extends from 'babel-runtime/helpers/extends';

import AuthorizePlans from '../authorize-dialog/components/authorize-plans.vue';
import _ from 'lodash';
import { upgradeGrant, getGrantRevenue } from '@/api/grant/grant';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },

    authorizeInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    AuthorizePlans: AuthorizePlans
  },
  computed: {
    rules: function rules() {
      var validateInit = function validateInit(rule, value, callback) {
        var reg = /(^[1-9]\d*$)/;
        if (reg.test(value) || value === 0) {
          callback();
        } else {
          callback(new Error('请输入正整数'));
        }
      };

      return {
        plan_id: [{ required: true, trigger: 'change', message: '请选择授权时间' }],
        revenue: [{
          required: true,
          trigger: 'change',
          validator: validateInit
        }]
      };
    },


    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    },

    dialogAttrs: function dialogAttrs() {
      return _extends({}, this.$attrs);
    }
  },
  data: function data() {
    return {
      loading: false,
      formValue: {
        id: '',
        grant_type: '',
        type: '',
        plan_id: '',
        revenue: 0 // 授权金额
      }
    };
  },


  watch: {
    dialogVisible: function dialogVisible(val) {
      if (val) {
        this.init(this.authorizeInfo);
      }
    },
    'formValue.plan_id': function formValuePlan_id() {
      this.fetchRevenue();
    }
  },

  methods: {
    init: function init(authorizeInfo) {
      this.formValue.grant_type = authorizeInfo.grant_type;
      this.formValue.type = authorizeInfo.plan_type;
      this.formValue.id = authorizeInfo.id;
    },
    closeDialog: function closeDialog() {
      var form = this.$refs.form;
      form.resetFields();
      form.clearValidate();
      this.$emit('update:visible', false);
    },
    handleSaveSuccess: function handleSaveSuccess() {
      this.closeDialog();
      this.$emit('save-success');
    },
    getDays: function getDays() {
      var date1 = new Date();
      var date2 = new Date(this.authorizeInfo.expired_time);
      var diffTime = Math.abs(date2 - date1);
      var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return diffDays;
    },
    fetchRevenue: function fetchRevenue() {
      var _this = this;

      // if (this.formValue.account_type === 'normal') {
      var params = this.getParams();
      getGrantRevenue({
        plan_id: params.plan_id,
        days: this.getDays()
      }, true /* 开启错误时候不展示错误消息 */
      ).then(function (res) {
        _this.formValue.revenue = res.data.data.revenue;
      });
      // }
    },
    getParams: function getParams() {
      var params = _.pick(this.formValue, ['id', 'plan_id', 'revenue']);

      return params;
    },
    submit: function submit() {
      var _this2 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          var params = _this2.getParams();

          _this2.loading = true;
          upgradeGrant(params).then(function (res) {
            _this2.handleSaveSuccess();
          }).finally(function () {
            _this2.loading = false;
          });
        }
      });
    }
  }
};